import { render, staticRenderFns } from "./showCustomForm.vue?vue&type=template&id=336a2cd7&scoped=true"
import script from "./showCustomForm.vue?vue&type=script&lang=js"
export * from "./showCustomForm.vue?vue&type=script&lang=js"
import style0 from "./showCustomForm.vue?vue&type=style&index=0&id=336a2cd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a2cd7",
  null
  
)

export default component.exports